import React, { useState } from 'react';

// 키워드 칩 입력 컴포넌트: Enter/쉼표로 구분, 백스페이스로 마지막 삭제, X로 개별 삭제
const KeywordsInput = ({ value = '', onChange, placeholder = '' }) => {
  const [input, setInput] = useState('');
  const tags = (value || '').split(',').map(s => s.trim()).filter(Boolean);

  const emit = (nextTags) => {
    const str = nextTags.join(',');
    onChange && onChange(str);
  };

  const addTag = (raw) => {
    const tag = (raw || '').trim();
    if (!tag) return;
    if (tags.includes(tag)) {
      setInput('');
      return;
    }
    emit([...tags, tag]);
    setInput('');
  };

  const removeAt = (idx) => {
    const next = tags.filter((_, i) => i !== idx);
    emit(next);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addTag(input);
    } else if (e.key === 'Backspace' && !input && tags.length > 0) {
      // 입력이 비어있고 백스페이스면 마지막 태그 삭제
      e.preventDefault();
      removeAt(tags.length - 1);
    }
  };

  return (
    <div className="block w-full px-2 py-1.5 bg-white focus-within:ring-1 focus-within:ring-blue-500 focus-within:border-blue-500">
      <div className="flex flex-wrap items-center gap-1">
        {tags.map((t, idx) => (
          <span key={`${t}-${idx}`} className="inline-flex items-center bg-blue-50 text-blue-700 text-xs px-2 py-1 rounded-full">
            {t}
            <button
              type="button"
              aria-label="remove keyword"
              className="ml-1 text-blue-600 hover:text-blue-800"
              onClick={() => removeAt(idx)}
            >
              ×
            </button>
          </span>
        ))}
        <input
          id="키워드-input"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder={tags.length === 0 ? placeholder : ''}
          className="flex-1 min-w-[120px] px-1 py-1 focus:outline-none text-sm"
        />
      </div>
    </div>
  );
};

export default KeywordsInput;
